// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MDButton } from './MDButton';
import { SessionOperations } from '@shared/utils/Enums/Constants';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { DataCache } from '@shared/commons/DataCache';
import { TerceraButtonEvents, TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
export class CancelOrdersMDButton extends MDButton {
    constructor() {
        super();
        this.lastUpdateTradingStatusId = null;
    }
    oninit() {
        super.oninit();
        const dc = DataCache;
        dc.OnAddOrder.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveOrder.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnAddSLOrderToPosition.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveSLOrderFromPosition.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnAddTPOrderToPosition.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveTPOrderFromPosition.Subscribe(this.deferUpdateTradingAllowedStatus, this);
        this.observe('instrument account', this.deferUpdateTradingAllowedStatus);
        TradingLockUtils.TradingLock.TradingLockChanged.Subscribe(this.updateTradingAllowedStatus, this);
        this.on(TerceraButtonEvents.onClick, this.cancelAllOrders);
    }
    dispose() {
        super.dispose();
        const dc = DataCache;
        dc.OnAddOrder.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveOrder.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnAddSLOrderToPosition.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveSLOrderFromPosition.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnAddTPOrderToPosition.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        dc.OnRemoveTPOrderFromPosition.UnSubscribe(this.deferUpdateTradingAllowedStatus, this);
        TradingLockUtils.TradingLock.TradingLockChanged.UnSubscribe(this.updateTradingAllowedStatus, this);
        if (this.lastUpdateTradingStatusId) {
            clearTimeout(this.lastUpdateTradingStatusId);
            this.lastUpdateTradingStatusId = null;
        }
    }
    // TODO. Optimization workaround - deferred execution.
    deferUpdateTradingAllowedStatus() {
        if (this.lastUpdateTradingStatusId) {
            clearTimeout(this.lastUpdateTradingStatusId);
        }
        this.lastUpdateTradingStatusId = setTimeout(() => {
            this.updateTradingAllowedStatus();
        }, 500);
    }
    updateTradingAllowedStatus() {
        const ins = this.get('instrument');
        const acc = this.get('account');
        const orderDict = DataCache.Trading.getOrdersByInstrumentAndAccount(ins, acc);
        const isTradingAllowed = IsAllowed.IsTradingAllowed(acc, ins, -1, SessionOperations.Cancel);
        void this.set('tradingAllowed', !!(orderDict && orderDict.length > 0 && isTradingAllowed.Allowed));
        void this.set('tradingForbiddenReason', isTradingAllowed.ReasonText);
    }
    // TODO. Optimize. UpdateTradingAllowedStatus after every OnAddOrder/OrRemoveOrder events.
    cancelAllOrders() {
        const orders = DataCache.Trading.getOrdersByInstrumentAndAccount(this.get('instrument'), this.get('account'));
        void DataCache.FOrderExecutor.cancelOrdersPromise(orders, true, PlacedFrom.WEB_MARKETDEPTH);
    }
}
MDButton.extendWith(CancelOrdersMDButton, {
    data: function () {
        return {
            locKey: 'Panels.MarketDepth.CancelAll',
            terceraButtonStyle: TerceraButtonStyle.Standard,
            instrument: null,
            account: null
        };
    }
});
